import { Button, Table, TableColumnsType, Typography } from "antd";
import React, { JSX, ReactNode } from "react";
import DownloadSecondaryTable, { SecondaryTableType } from "./DownloadTableSecondary";
import { formatBytes } from "./DownloadUtils";

const { Text, } = Typography;

export interface PrimaryTableType {
  key: React.Key;
  LicenseNumber: string;
  RequestedUWI: string;
  WellIdentifier: {
    Id: string;
    LicenseNumber: string;
    OriginalUWI: string;
    File: SecondaryTableType[];
  }
}

export interface DownloadTablePrimaryProps {
  order: number;
  data: PrimaryTableType[];
  downloadHandler: (order: number, uwi?: string, file?: string) => void;
}

const sum = (acc: number, cur: number) => acc + cur;

const DownloadPrimaryTable = (props: DownloadTablePrimaryProps): JSX.Element => {

  const columns: TableColumnsType<PrimaryTableType> = [
    {
      title: "",
      dataIndex: ["WellIdentifier", "Id"],
      render: (_value, _record, index) => {
        return `${index + 1}.`
      },
      align: "right",
      width: "3ch",
    },
    {
      title: "Requested UWI",
      dataIndex: ["RequestedUWI"],
    },
    {
      title: "License",
      dataIndex: ["LicenseNumber"],
    },
    {
      title: "# Files",
      dataIndex: ["WellIdentifier", "Id"],
      render: (_value, record) => {
        return (record?.WellIdentifier?.File ?? []).length;
      },
      align: "right",
    },
    {
      title: "File(s) Size",
      dataIndex: ["WellIdentifier", "Id"],
      render: (_value, record) => {
        return formatBytes((record?.WellIdentifier?.File ?? []).map(file => file.Size ?? 0).reduce(sum, 0));
      },
    },
    {
      title: "",
      dataIndex: ["RequestedUWI"],
      render: (value) => {
        return (
          <Button type="primary" onClick={() => props.downloadHandler(props.order, value)}> Download </Button>
        );
      },
      align: "right",
    },
    Table.EXPAND_COLUMN,
  ];

  const expandedRowRender = (record: any): ReactNode => {
    return <DownloadSecondaryTable
      order={props.order}
      uwi={record.RequestedUWI}
      data={record.WellIdentifier.File ?? []}
      downloadHandler={props.downloadHandler}
    />;
  };

  return (
    <div>
      <Table
        columns={columns}
        rowKey={(record) => record.WellIdentifier.OriginalUWI}
        dataSource={props.data}
        bordered={true}
        pagination={false}
        expandable={{ expandedRowRender, defaultExpandAllRows: true }}
        summary={(pageData) => {
          const totalUwis = pageData.length;
          const totalFiles = pageData.map(i => i.WellIdentifier.File.length).reduce(sum, 0);
          const totalBytes = pageData.map(i => i.WellIdentifier.File.map((file: any) => (file.Size ?? 0)).reduce(sum, 0)).reduce(sum, 0);
          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={1}><Text strong={true}>Total UWIs: <br />{totalUwis}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3}><Text strong={true}>Total Files: <br />{totalFiles}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={4}><Text strong={true}>Total Size: <br />{formatBytes(totalBytes)}</Text></Table.Summary.Cell>
              <Table.Summary.Cell index={5}></Table.Summary.Cell>
              <Table.Summary.Cell index={6}></Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </div>
  );
};

export default DownloadPrimaryTable;
